export const LAWYER_IMG_1 =
  "/images/pro1.jpg";
export const LAWYER_IMG_2 =
  "/images/pro2.jpg";
export const LAWYER_IMG_3 =
  "/images/pro3.jpg";
export const LAWYER_IMG_4 =
  "/images/pro4.jpg";
export const LOGO_IMG =
  "/images/logo_te.png";
export const LOGO_IMG_WHITE =
  "/images/logo_wh.png";
export const OFFICE_IMG =
  "/images/bg1.webp";
export const HERO_BG =
  "/images/bg2.jpg";
export const CENTER_BG =
  "/images/bg3.jpg";
export const CERT_IMG =
  "/images/law_de.webp";

export interface PracticeArea {
  id: string;
  title: string;
  desc: string;
  icon: string;
  items: string[];
}

export const practiceAreas: PracticeArea[] = [
  {
    id: "seongbeom",
    title: "성범죄",
    desc: "재판부의 판단 기준을 아는 부장판사 출신 변호사가 선제적으로 대응합니다.",
    icon: "ri-shield-check-line",
    items: ["성폭력범죄", "미투·직장 내 성범죄", "성인지 감수성 사건", "아동·청소년 성범죄"],
  },
  {
    id: "traffic",
    title: "교통범죄 (음주·뺑소니)",
    desc: "음주운전, 뺑소니 등 교통사건의 초기 대응부터 합의·재판까지 원스톱.",
    icon: "ri-car-line",
    items: ["음주운전", "뺑소니", "무면허·도주치상", "교통사고처리특례법"],
  },
  {
    id: "fraud",
    title: "사기·횡령·배임",
    desc: "고소·피고소 양측 모두, 사건의 실체를 꿰뚫는 정밀한 논리로 대응.",
    icon: "ri-file-shield-2-line",
    items: ["사기죄", "횡령·배임", "보이스피싱", "경제사범·금융사기"],
  },
  {
    id: "drug",
    title: "마약·도박",
    desc: "마약·도박 사건의 수사 대응과 처분 단계별 맞춤 전략을 제시합니다.",
    icon: "ri-flask-line",
    items: ["마약류범죄", "도박·도박개장", "대마·향정", "수사 방어 전략"],
  },
  {
    id: "divorce",
    title: "이혼",
    desc: "재산분할·양육권·위자료까지, 부장판사 출신의 시각으로 유리한 조건을 설계.",
    icon: "ri-heart-2-line",
    items: ["협의이혼", "재판이혼", "재산분할·양육권", "위자료 청구"],
  },
  {
    id: "inherit",
    title: "상속·가사",
    desc: "상속분쟁·유류분·가사사건을 법원 실무에 맞춰 신속하게 해결합니다.",
    icon: "ri-home-4-line",
    items: ["상속분쟁", "유류분 청구", "한정승인·상속포기", "가사소송"],
  },
  {
    id: "school",
    title: "학교폭력",
    desc: "학생·학부모 양측 모두, 학교폭력 사건의 교육적·법적 해결을 돕습니다.",
    icon: "ri-community-line",
    items: ["학교폭력 조치", "학폭위 대응", "학교폭력 피해·가해", "징계 취소청구"],
  },
  {
    id: "admin",
    title: "행정 (인허가·취소소송·조세)",
    desc: "인허가·취소소송·조세 등 행정사건에 대한 전문적인 대응을 제공합니다.",
    icon: "ri-building-2-line",
    items: ["인허가 취소소송", "조세·세무분쟁", "행정처분 취소", "영업정지·폐쇄 대응"],
  },
  {
    id: "civil",
    title: "민사 (부동산·가처분·손해배상)",
    desc: "부동산·가처분·손해배상 등 민사분쟁을 실질적 권리구제로 이끕니다.",
    icon: "ri-bank-line",
    items: ["부동산 분쟁", "가처분·가압류", "손해배상 청구", "계약·채권분쟁"],
  },
  {
    id: "corporate",
    title: "기업법무 (노동·중대재해·자문)",
    desc: "노동·중대재해·자문 등 기업의 리스크를 사전에 차단하는 법무 파트너.",
    icon: "ri-briefcase-4-line",
    items: ["노동·해고분쟁", "중대재해처벌법", "기업 자문·컨설팅", "부당노동행위"],
  },
  {
    id: "corp-bankrupt",
    title: "법인파산",
    desc: "법인회생·파산·워크아웃을 전문 센터와 연계해 기업을 살립니다.",
    icon: "ri-building-4-line",
    items: ["법인회생", "법인파산", "워크아웃·기업구조개선", "채무자·채권자 대응"],
  },
  {
    id: "personal-bankrupt",
    title: "개인파산",
    desc: "개인회생·개인파산·면책까지, 회생파산센터의 전문 프로세스로 상담합니다.",
    icon: "ri-user-3-line",
    items: ["개인회생", "개인파산", "면책·변제계획", "신용회복 지원"],
  },
];

export interface ExperienceItem {
  year: string;
  title: string;
  sub: string;
}

export const experiences: ExperienceItem[] = [
  {
    year: "2001",
    title: "사법연수원 제31기 수료",
    sub: "· 1999년 제41회 사법시험 합격",
  },
  {
    year: "2002",
    title: "검사경력",
    sub: "· 2005년 전주지방검찰청 군산지청 검사\n· 2007년 광주지방검찰청 검사 (법무부장관, 검찰총장 표창)\n· 2009년 광주지방검찰청 순천지청 검사",
  },
  {
    year: "2003",
    title: "광주지방법원 부장판사",
    sub: "· 2010년 광주지방법원판사\n· 2013년 광주고등법원판사\n· 2015년 광주지방법원 · 광주가정법원 목포지원 판사\n· 2017년 광주지방법원 판사\n· 2018년 대전지방법원 부장판사\n· 2020년 광주지방법원 부장판사\n· 2021년 광주 서구 선거관리위원장 (겸직)\n· 2025년 광주지방법원 부장판사 (퇴직)",
  },
  {
    year: "2025",
    title: "법무법인 평율 대표변호사",
    sub: "모든 사건에 대해서 직접 상담 및 변론수행",
  },
];

export interface PressItem {
  media: string;
  date: string;
  title: string;
  desc: string;
  url: string;
}

export const pressItems: PressItem[] = [
  {
    media: "경상일보",
    date: "2026.06.15",
    title: "교통사고 후 형사처벌, 전문가와 초기 대응 중요해져",
    desc: "교통사고 발생 시 초기 대응과 형사처벌 쟁점 검토의 중요성을 강조하며, 사고 경위와 법적 쟁점을 함께 살피는 전문가 상담의 필요성을 전했습니다.",
    url: "https://www.ksilbo.co.kr/news/articleView.html?idxno=1059465",
  },
  {
    media: "더파워",
    date: "2026.03.12",
    title: "배우자 외도, 위약벌 조항 적극 활용하세요",
    desc: "배우자의 외도로 인한 이혼·손해배상 청구와 함께, 상간자 소송 이후 관계를 끊어내는 위약벌 조항 활용 전략을 소개했습니다.",
    url: "https://www.thepowernews.co.kr/view.php?ud=2026031115463139946cf2d78c68_7",
  },
  {
    media: "비욘드포스트",
    date: "2026.01.16",
    title: "12대 중과실 교통사고, 형사적 책임 피할 수 없어",
    desc: "12대 중과실 교통사고의 형사적 책임과 초기 대응의 중요성을 짚으며, 사안에 맞는 전문가 조력을 권했습니다.",
    url: "https://www.beyondpost.co.kr/view.php?ud=2026011613371436146cf2d78c68_30",
  },
  {
    media: "경상일보",
    date: "2025.12.12",
    title: "전세사기로 보증금 돌려받지 못했다면 민사소송 검토가 먼저",
    desc: "전세보증금을 돌려받지 못한 세입자를 위한 보증이행 청구와 민사소송, 임차권등기명령 등 단계별 대응법을 설명했습니다.",
    url: "https://www.ksilbo.co.kr/news/articleView.html?idxno=1044061",
  },
  {
    media: "라이브뉴스",
    date: "2025.11.12",
    title: "외도로 인한 정신적 고통 보상…이혼 변호사와 전략적 접근 필요",
    desc: "외도로 인한 정신적 고통에 대한 위자료 청구와 이혼소송까지, 감정적 대응보다 전략적 법률 접근이 필요하다고 조언했습니다.",
    url: "https://www.livesnews.com/news/article.html?no=56489",
  },
  {
    media: "글로벌에픽",
    date: "2025.10.28",
    title: "음주 재범, 형사와 행정 등 다각도로 접근해야",
    desc: "음주운전 재범 사안에 대해 형사처벌과 행정처분을 아우르는 다각도의 접근이 필요하다는 김평호 변호사의 견해를 전했습니다.",
    url: "https://www.globalepic.co.kr/view.php?ud=2025102809342129636cf2d78c68_29",
  },
];

export interface CaseItem {
  id: number;
  category: string;
  title: string;
  desc: string;
  content: string[];
  result: string;
  date: string;
  thumbnail: string;
  judgments: string[];
}

export const caseCategories = ["형사", "민사", "가사", "개인·법인파산", "행정", "기업법무"];

export const caseItems: CaseItem[] = [
  {
    id: 1,
    category: "민사",
    title: "회사 자금 4억 3,000만 원 유용, 손해배상청구 전부 인정",
    desc: "회사 자금을 개인 용도로 사용한 직원을 상대로 불법행위 책임과 각서에 기한 약정금 청구를 함께 구성해 미반환 금액 전액의 배상을 이끌어냈습니다.",
    content: [
      "회사의 자금을 관리·집행하는 업무를 담당하던 직원이 회사 돈을 개인적인 용도로 사용한 뒤 일부만 반환하고 나머지를 돌려주지 않은 사안입니다. 의뢰인인 원고는 미반환 금액을 회수하기 위해 법적 대응에 나서게 되었습니다.",
      "이 사건의 핵심은 회사 자금의 사용 경위와 함께 이를 어떤 법적 근거로 청구할 것인지였습니다. 법무법인 평율은 주위적으로 피고의 회사 자금 유용 행위에 따른 불법행위 책임을 주장하고, 예비적으로는 피고가 작성한 각서를 근거로 한 약정금 지급 의무를 함께 주장하는 방식으로 청구취지를 구성하였습니다.",
      "그 결과 법원은 원고의 청구를 받아들여 원고 승소 판결을 선고하였습니다. 하나의 법률상 원인에 그치지 않고 자금 사용행위와 이후 작성된 각서까지 종합해 청구원인을 다각도로 구성한 사례입니다.",
    ],
    result: "전부 승소 (142,510,090원 지급)",
    date: "2026.01",
    thumbnail:
      "/images/bg4.jpg",
    judgments: [
      "/images/com1.webp",
    ],
  },
  {
    id: 2,
    category: "민사",
    title: "5,000만 원 상당 물품대금 청구, 공급 사실 입증해 원고 승소",
    desc: "물품 공급 사실 자체를 부인한 상대방을 상대로 차량운행일지·기사 진술·세금계산서 등 객관적 자료를 종합해 공급 경위를 입증하고 항소심까지 승소했습니다.",
    content: [
      "원고가 피고에게 약 5,000만 원 상당의 레미콘을 공급하였음에도, 피고가 물품 공급 사실 자체를 부인하며 대금 지급을 거절한 사안입니다.",
      "법무법인 평율은 거래명세서나 세금계산서만을 근거로 삼지 않고, 차량에 부착된 특수장치 기록과 차량운행일지·운행일보, 실제 운행에 참여한 기사들의 진술, 세금계산서 발급 내역 등을 종합·대조하여 공급 경위와 공급량을 구체적으로 입증하였습니다.",
      "특히 운행일지에 기재된 차량번호·기사명·출발·도착시간 및 운반량의 합계가 거래명세서상 공급량과 일치한다는 점을 강조했습니다. 그 결과 제1심 법원은 원고의 청구를 받아들였고, 항소심인 광주지방법원 역시 1심의 사실인정이 정당하다며 피고의 항소를 기각하였습니다.",
    ],
    result: "원고 승소 (항소 기각)",
    date: "2026.08",
    thumbnail:
      "/images/bg5.jpg",
    judgments: [
      "/images/com2.webp",
    ],
  },
  {
    id: 3,
    category: "가사",
    title: "재산분할 3억 1,000만 원 → 1억 8,900만 원 감액, 친권·양육권까지 변경",
    desc: "제1심에서 불리한 판결을 받은 의뢰인을 위해 항소심에서 혼인 파탄의 주된 책임과 재산 형성 기여도를 입증해 분할금 감액과 친권·양육권 변경을 이끌어냈습니다.",
    content: [
      "제1심에서 의뢰인이 상대방에게 재산분할로 약 3억 1,000만 원을 지급하고, 두 자녀의 친권자 및 양육자 역시 상대방으로 지정되는 불리한 판결이 선고된 사안입니다.",
      "평율은 항소심에서 상대방에게 혼인관계 파탄에 대한 주된 책임이 있다는 점을 적극 주장·입증하는 한편, 재산분할의 핵심이 되는 상대방의 재산관계를 면밀히 확인하였습니다. 단순히 현재 명의만을 보는 것이 아니라 혼인기간 동안의 재산 형성·유지 기여도를 다투어 의뢰인의 기여도를 55%로 인정받았습니다.",
      "그 결과 항소심에서 부담할 재산분할금이 1심 약 3억 1,000만 원에서 1억 8,900만 원으로 크게 감액되었고, 상대방의 파탄 책임이 인정되어 위자료 1,000만 원을 지급받게 되었습니다. 또한 두 자녀 중 1명의 친권자 및 양육자를 의뢰인으로 지정하는 내용으로 제1심의 판단까지 변경되었습니다.",
    ],
    result: "재산분할 감액 (3.1억→1.89억) · 친권·양육권 변경",
    date: "2026.06",
    thumbnail:
      "/images/bg6.jpg",
    judgments: [
      "/images/com3.webp",
      "/images/com4.webp",
      "/images/com5.webp",
    ],
  },
  {
    id: 4,
    category: "형사",
    title: "제1심 징역 3년 법정구속, 항소심에서 집행유예로 방어",
    desc: "아동·청소년 성보호법 위반·마약류관리법 위반 등으로 제1심에서 실형을 선고받고 구속된 의뢰인을 항소심에서 변호해 집행유예 판결을 이끌어냈습니다.",
    content: [
      "아동·청소년의 성보호에 관한 법률 위반, 마약류관리에 관한 법률 위반, 미성년자의제유사강간 등 여러 혐의로 제1심에서 징역 3년과 성폭력 치료프로그램 이수, 취업제한 처분을 선고받고 법정구속된 사안입니다.",
      "법무법인 평율은 항소심에서 기록을 면밀히 검토하여 피고인에게 유리하게 참작될 정상관계를 적극적으로 주장했습니다. 범행 후 태도와 반성 여부, 피해자들과의 관계 및 피해회복을 위한 노력, 사건의 구체적인 경위 등 양형에 영향을 미칠 사정을 종합적으로 정리해 재판부에 설명했습니다.",
      "그 결과 항소심 법원은 제1심의 형을 그대로 유지하지 않고 징역 3년을 선고하되 판결 확정일부터 5년간 그 형의 집행을 유예하는 판결을 선고하였습니다. 이에 따라 법정구속되었던 의뢰인은 수감생활을 종료하고 사회로 복귀할 수 있게 되었습니다.",
    ],
    result: "징역 3년 · 집행유예 5년",
    date: "2025.06",
    thumbnail:
      "/images/bg7.jpg",
    judgments: [
      "/images/com6.webp",
      "/images/com7.webp",
    ],
  },
  {
    id: 5,
    category: "형사",
    title: "음주운전 벌금형 확정 후 재범, 실형 대신 벌금형으로 방어",
    desc: "음주운전 벌금형 확정 후 2주 만에 무면허 음주운전으로 재판받은 의뢰인을 변호해, 수감 없이 벌금형을 이끌어낸 사례입니다.",
    content: [
      "의뢰인은 2025년 8월 음주운전으로 벌금 500만 원의 약식명령을 받아 9월 11일 확정되었는데, 불과 2주 뒤인 9월 25일 다시 음주운전을 하며 재판을 받게 되었습니다. 당시 무면허 상태에서 혈중알코올농도 0.095%로 약 1km를 운전하여 음주운전과 무면허운전 혐의가 함께 문제되었습니다.",
      "법무법인 평율은 범행을 무리하게 부인하기보다 사실관계를 정확히 인정하고, 잘못을 반성하고 있다는 점, 혈중알코올농도가 비교적 높지 않았다는 점, 운전거리가 약 1km로 짧았다는 점 등을 구체적으로 설명하며 재범 위험성이 높지 않다는 점을 적극 주장했습니다.",
      "재판부는 재범 사안의 죄책이 가볍지 않다고 보면서도 반성 태도, 주취 정도, 운전거리, 범행 경위와 후 정황을 종합해 벌금 2,000만 원을 선고하였습니다. 실형 선고 우려가 있던 상황에서 의뢰인은 수감생활 없이 사회생활을 이어갈 수 있게 되었습니다.",
    ],
    result: "벌금 2,000만 원",
    date: "2026.05",
    thumbnail:
      "/images/bg8.jpg",
    judgments: [
      "/images/com8.webp",
    ],
  },
  {
    id: 6,
    category: "형사",
    title: "살인미수·음주운전 사건, 집행유예로 방어",
    desc: "살인미수와 고혈중알코올 음주운전으로 재판받은 의뢰인을 위해 모든 양형 요소를 체계적으로 정리해 징역 3년·집행유예 5년을 이끌어냈습니다.",
    content: [
      "피고인이 피해자를 살해하려 한 혐의와 음주운전 혐의로 재판받은 사안입니다. 거래대금 문제로 감정이 격해져 미리 준비한 흉기를 피해자의 목 부위로 여러 차례 휘둘렀으나, 피해자가 저항하고 직원이 제지하여 미수에 그쳤습니다. 같은 날 혈중알코올농도 0.228% 상태로 약 2.9km를 운전하였고, 과거 음주운전 전력도 있어 실형 가능성을 배제하기 어려운 상황이었습니다.",
      "법무법인 평율은 사건의 구체적인 경위와 피고인의 범행 당시 상태, 피해자의 상해 정도, 피해 회복 및 합의 관련 사정을 면밀히 검토하여 재판부에 유리한 양형 사정을 적극적으로 설명했습니다.",
      "재판부는 살인미수 범행이 미수에 그친 점, 피해자가 주요 장기나 혈관에 중대한 손상을 입지 않은 점, 범행 당시 과음으로 판단력이 다소 저하되었던 점, 피해자의 처벌불원 의사, 반성하는 태도 등을 종합적으로 고려하여 징역 3년에 집행유예 5년, 80시간 사회봉사 및 40시간 준법운전강의 수강을 명하였습니다.",
    ],
    result: "징역 3년 · 집행유예 5년",
    date: "2026.08",
    thumbnail:
      "/images/bg9.jpg",
    judgments: [
      "/images/com9.webp",
    ],
  },
];

export interface StepItem {
  step: string;
  title: string;
  desc: string;
  icon: string;
  image: string;
}

export const steps: StepItem[] = [
  {
    step: "STEP 01",
    title: "맞춤 상담",
    desc: "1:1 맞춤 상담으로 사건의 쟁점을 정확히 파악하고 예상 시나리오를 제시합니다.",
    icon: "ri-phone-line",
    image:
      "/images/bg10.jpg",
  },
  {
    step: "STEP 02",
    title: "사건 분석",
    desc: "부장판사 출신의 시각으로 수사기록·증거를 분석해 가장 유리한 전략을 설계합니다.",
    icon: "ri-search-eye-line",
    image:
      "/images/bg11.jpg",
  },
  {
    step: "STEP 03",
    title: "전략 수립",
    desc: "수사·재판 단계별 맞춤 대응으로 의뢰인의 권리를 최대한 보호합니다.",
    icon: "ri-compass-3-line",
    image:
      "/images/bg12.jpg",
  },
  {
    step: "STEP 04",
    title: "사건 진행",
    desc: "원스톱 프로세스로 수사부터 재판·집행까지 끝까지 함께합니다.",
    icon: "ri-flag-2-line",
    image:
      "/images/bg13.jpg",
  },
];

export interface CriminalType {
  id: string;
  title: string;
  desc: string;
  points: string[];
  icon: string;
}

export const criminalTypes: CriminalType[] = [
  {
    id: "sexual",
    title: "성범죄",
    desc: "성폭력·성희롱·몰카 등 성범죄는 신속 대응이 가장 중요합니다.",
    icon: "ri-shield-check-line",
    points: ["피해자·피고인 양측 대응", "성인지 감수성 쟁점 분석", "합의·선처 주선"],
  },
  {
    id: "traffic",
    title: "교통범죄",
    desc: "음주운전·뺑소니·도주치상 등 교통사건, 초기 대응이 결과를 가릅니다.",
    icon: "ri-car-line",
    points: ["음주운전·면허취소 대응", "뺑소니·도주치상 방어", "보험·합의 조율"],
  },
  {
    id: "fraud",
    title: "사기·횡령·배임",
    desc: "경제사범은 기록 분석과 논리 구성이 승패를 좌우합니다.",
    icon: "ri-file-shield-2-line",
    points: ["고소·피고소 대응", "보이스피싱 방어", "배임·횡령 무죄 논리"],
  },
  {
    id: "drug",
    title: "마약·도박",
    desc: "마약·도박 사건은 수사 단계에서의 방어가 결정적입니다.",
    icon: "ri-flask-line",
    points: ["수사 단계 방어", "처분 단계별 전략", "재범 방지·선처 주장"],
  },
  {
    id: "violence",
    title: "폭력·협박",
    desc: "폭행·협박·특수폭행 등 폭력사건의 정당방위·과잉방위 쟁점을 다룹니다.",
    icon: "ri-alert-line",
    points: ["폭행·상해 대응", "정당방위 입증", "합의·선처 단계별 전략"],
  },
  {
    id: "school",
    title: "학교폭력",
    desc: "학교폭력 사건은 징계·형사절차가 함께 진행되어 전문 대응이 필요합니다.",
    icon: "ri-community-line",
    points: ["학폭위 대응", "징계 취소청구", "피해·가해 양측 지원"],
  },
];